export default function CTALayerRenderer({ layer }) {
  const data = layer.data;
  const s = data.style;
  const pad = s.padding || [12, 24, 12, 24];

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div
        style={{
          background: s.backgroundColor,
          color: s.color,
          fontSize: s.fontSize,
          fontWeight: s.fontWeight,
          borderRadius: s.borderRadius,
          padding: `${pad[0]}px ${pad[1]}px ${pad[2]}px ${pad[3]}px`,
          border: s.border || 'none',
          display: 'inline-block',
          fontFamily: 'Inter, sans-serif',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {data.text || 'CTA Button'}
      </div>
    </div>
  );
}
